document.addEventListener("DOMContentLoaded", function () {
  // Select the mobile-only tabbed content wrapper
  const mobileTabsWrapper = document.querySelector(".membership-tabs-wrapper.mobile-only");

  // Ensure the wrapper is found before proceeding
  if (!mobileTabsWrapper) return;

  // Get all tab navigation items and content blocks within the mobile layout
  const tabs = mobileTabsWrapper.querySelectorAll(".membership-tabs-nav li");
  const tabContents = mobileTabsWrapper.querySelectorAll(".membership-tabs-content .tab-content");

  // Add click event listeners to each tab
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      // Remove 'active' class from all tabs and tab contents
      tabs.forEach(item => item.classList.remove("active"));
      tabContents.forEach(content => content.classList.remove("active"));

      // Add 'active' class to the clicked tab and corresponding content
      tab.classList.add("active");
      tabContents[index].classList.add("active");
    });
  });

  // Activate the first tab content by default on page load
  if (tabContents.length > 0) {
    tabContents[0].classList.add("active");
  }

  // Add images to the tab navigation
  tabContents.forEach((content, index) => {
    const image = content.querySelector("img");
    if (image) {
      const tab = tabs[index];
      tab.insertAdjacentHTML("afterbegin", image.outerHTML);
    }
  });

  // Show only the active tab content on load
  tabContents.forEach((content, index) => {
    if (index !== 0) {
      content.style.display = "none";
    }
  });

  // Add click events to toggle visibility of tab content
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      // Hide all tab contents
      tabContents.forEach(content => content.style.display = "none");

      // Show the selected tab content
      tabContents[index].style.display = "block";
    });
  });
});
